import React from "react";
import { IconButton, Tooltip } from "@mui/joy";
import { SxProps } from "@mui/joy/styles/types";

export type CardActionColor = "neutral" | "primary" | "danger" | "warning" | "success";

interface Props {
    icon: React.ReactNode;
    tooltip: string;
    onClick: () => void;
    color?: CardActionColor;
    sx?: SxProps;
    ariaLabel?: string;
    disabled?: boolean;
    /** `data-testid` of the button (e2e). */
    testId?: string;
}

/** Soft icon button used for card actions (Edit / Delete / Renew, …). */
const CardActionButton = ({ icon, tooltip, onClick, color = "neutral", sx, ariaLabel, disabled, testId }: Props) => (
    <Tooltip title={tooltip}>
        <IconButton
            variant="soft"
            color={color}
            onClick={onClick}
            disabled={disabled}
            aria-label={ariaLabel ?? tooltip}
            sx={sx}
            data-testid={testId}
        >
            {icon}
        </IconButton>
    </Tooltip>
);

export default CardActionButton;
